import { c as _c } from "react/compiler-runtime";
import { BrowserRouter } from "react-router";
import { QueryProvider } from "@/providers/query-provider";
import { useMetrika, useMetrikaPageHits } from "@/api/use-metrika";
import { captureAdsLanding } from "@/lib/discovery-source";
import { captureReferralPromo } from "@/lib/referral-promo";
import { useReferralPromo } from "@/lib/use-referral-promo";
import { captureShopInvite } from "@/lib/shop-invite";
import { useShopInvite } from "@/lib/use-shop-invite";
import { AppRoutes } from "./router";
import "./index.css";

// fd-analytics-05: инициализация счётчика Яндекс.Метрики единожды в корне SPA.
function MetrikaLoader() {
  useMetrika();
  return null;
}

// Рекламный переход помечается один раз при загрузке витрины, ДО первого
// рендера: метки кампании живут в адресе посадочной страницы, а первый же
// переход внутри SPA его перепишет.
captureAdsLanding(typeof window === "undefined" ? "" : window.location.search);
// Партнёрская ссылка ?promo=CODE — так же до первого рендера.
captureReferralPromo(typeof window === "undefined" ? "" : window.location.search);
// Ссылка магазина ?from=shop:<код> (клиенты продавцов) - тоже до рендера.
captureShopInvite(typeof window === "undefined" ? "" : window.location.search);

// Просмотры страниц при переходах внутри SPA - нужен контекст роутера.
function MetrikaPageHits() {
  useMetrikaPageHits();
  return null;
}
function ReferralTracker() {
  useReferralPromo();
  useShopInvite();
  return null;
}
export function App() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MetrikaLoader />;
    t1 = <ReferralTracker />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <QueryProvider>{t0}{t1}<BrowserRouter><MetrikaPageHits /><AppRoutes /></BrowserRouter></QueryProvider>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default App;